export declare type PageBlockDescriptor = {
	uuid: string;
	type: string;
};

export class EditorPage {
	uuid: string;
	index: number;
	name: string | null;
	blocks: Array<PageBlockDescriptor>;
	questionUuids: Array<string>;

	constructor(
		uuid: string, index: number, name: string | null
	) {
		this.uuid = uuid;
		this.index = index;
		this.name = name;
		this.blocks = [];
		this.questionUuids = [];
	}

	/**
	 * Expects to be called in sequence that the blocks appear
	 *
	 * Does not support "insertion" other than "appending"
	 **/
	addBlock(blockInfo: {[key: string]: any}) {
		this.blocks.push({
			uuid: blockInfo.uuid,
			type: blockInfo.content[0].type
		});

		if (blockInfo.content[0].type === 'question_container') {
			this.questionUuids.push(
				blockInfo.content[0].attrs.uuid
			);
		}
	}
}
